export const getImports = state => state.search.imports;
export const getImportRequests = state => state.search.importRequests;
export const isFetching = state => state.search.isFetching;

export const getMeta = state => state.search.meta;
export const getAllIds = state => getMeta(state).allIds;
export const getCurrentPage = state => getMeta(state).currentPage;
export const getPageSize = state => getMeta(state).pageSize;
export const getTotalCount = state => getMeta(state).totalCount;
export const getTodalPages = state => getMeta(state).totalPages;
